import React from 'react';

import { SVGComponentProps } from './svg.types';

const MarketingOnboardSVG = ({
  fill = 'currentColor',
  size = '1em',
  wrapperClass,
  ...otherProps
}: SVGComponentProps) => {
  return (
    <span className={`inline-block ${wrapperClass || ''}`}>
      <svg
        width={size}
        height={size}
        viewBox="0 0 25 24"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        {...otherProps}
      >
        <path
          d="M9.66602 17C9.66602 17 16.666 18 19.666 21H20.666C21.2183 21 21.666 20.5523 21.666 20V13.937C22.5286 13.715 23.166 12.9319 23.166 12C23.166 11.0681 22.5286 10.285 21.666 10.063V4C21.666 3.44772 21.2183 3 20.666 3H19.666C16.666 6 9.66602 7 9.66602 7H5.66602C4.56145 7 3.66602 7.89543 3.66602 9V15C3.66602 16.1046 4.56145 17 5.66602 17H6.66602L7.66602 22H9.66602V17ZM11.666 8.6612C12.3493 8.5146 13.1935 8.31193 14.1053 8.04373C15.7835 7.55014 17.916 6.77262 19.666 5.57458V18.4254C17.916 17.2274 15.7835 16.4499 14.1053 15.9563C13.1935 15.6881 12.3493 15.4854 11.666 15.3388V8.6612ZM5.66602 9H9.66602V15H5.66602V9Z"
          fill={fill}
        />
      </svg>
    </span>
  );
};

export default MarketingOnboardSVG;
